import { BBDTag, Horizontal, MaterialIcon } from '@gravitate-js/excalibrr'
import type { DeliveryReconOverviewRow } from '../types'

type StatusTagProps = {
  status: DeliveryReconOverviewRow['status']
  type: DeliveryReconOverviewRow['type']
}

export function StatusTag({ status, type }: StatusTagProps) {
  const isApproved = status.toLowerCase() === 'approved'
  const isVoid = status.toLowerCase() === 'voided'
  const isUnmatched = status.toLowerCase().includes('unmatched')
  const isMatched = status.toLowerCase() === 'matched'
  const label = type === 'bol' ? 'Ord' : 'Meas.'
  return (
    <Horizontal width='100%'>
      {isApproved && (
        <BBDTag
          className='text-ellipsis'
          color='success'
          icon={
            <MaterialIcon className='pr-1' size={14} style={{ position: 'relative', top: 3 }} icon='check_circle' />
          }
        >
          Approved
        </BBDTag>
      )}
      {isVoid && (
        <BBDTag
          className='text-ellipsis'
          icon={<MaterialIcon className='pr-1' size={14} style={{ position: 'relative', top: 3 }} icon='cancel' />}
        >
          Voided
        </BBDTag>
      )}
      {isUnmatched && (
        <BBDTag
          className='text-ellipsis'
          color='error'
          icon={<MaterialIcon className='pr-1' size={14} style={{ position: 'relative', top: 3 }} icon='link_off' />}
        >
          <span className='pr-1' style={{ fontSize: 10 }}>
            {label}
          </span>
          Unmatched
        </BBDTag>
      )}
      {isMatched && (
        <BBDTag
          className='text-ellipsis'
          color='warning'
          icon={<MaterialIcon className='pr-1' icon='link' size={14} style={{ position: 'relative', top: 3 }} />}
        >
          Matched
        </BBDTag>
      )}
    </Horizontal>
  )
}
